import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router';
import { logClick } from './api';

/**
 * The action pages of Note spese (#739): the email's button lands with `?onboarding=<step>`. On
 * arrival, once, the step is logged (`POST /v1/profile/communications/clicks`, fire and forget: a
 * failure never shows anything) and the parameter is removed from the address with `replace`.
 */
export function useOnboardingClick(): void {
  const [params, setParams] = useSearchParams();
  const step = params.get('onboarding');
  const sent = useRef(false);

  useEffect(() => {
    if (step === null) return;
    if (!sent.current) {
      sent.current = true;
      if (step !== '') void logClick(step);
    }
    setParams(
      (current) => {
        const next = new URLSearchParams(current);
        next.delete('onboarding');
        return next;
      },
      { replace: true },
    );
  }, [step, setParams]);
}
